import { Component, OnInit, ViewChild } from '@angular/core';
import {
  PermitService, PermitDetailsModel, PermitDetailsItemModel,
  PermitDetailsVehicleItemModel, PermitDetailsBillingItemModel,
  PermitDetailsTransactionItemModel
} from '../../../src/app/services/permit.service';
import { ErrorHandlingService, LocalParserFormatter } from 'core-lib';
import * as moment from 'moment';
import * as _ from 'lodash';
import { YesCancelModalComponent } from '../modals/yes-cancel-modal/yes-cancel-modal.component';
import { Router } from '@angular/router';
import { StateService } from '../services/state.service';

@Component({
  selector: 'cli-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  public vm: DashboardViewModel;
  public vehicles: Array<any>;
  public currentRate: any;
  public ios: string;
  public android: string;

  @ViewChild('goRenewModal')
  public goRenewModal: YesCancelModalComponent;

  constructor(private permitService: PermitService,
    private errorHandlingSvc: ErrorHandlingService,
    private formatter: LocalParserFormatter,
    private router: Router,
    private stateSvc: StateService) { this.vm = new DashboardViewModel(); }

  ngOnInit() {
    this.vm.isLoading = true;
    this.vm.isOpening = !this.permitService.model;

    this.permitService.getVehicles().subscribe(result => {
      this.vehicles = result.data;
    });

    this.permitService.getCurrentRate().subscribe(result => {
      this.currentRate = result.data.item;
    });

    this.permitService.getDetails().toPromise().then((data: PermitDetailsModel) => {

      this.mapModel(this.vm, data);
    },
      (e) => {
        this.errorHandlingSvc.processHttpError(e);

      }).finally(() => {

        this.vm.isLoading = false;
        this.vm.isOpening = false;

        if (this.vm.isRenewable && this.vm.status === 'Active' && !this.stateSvc.isRenewOfferShown) {

          this.goRenewModal.message = 'Your permit needs to be renewed. Proceed to renewal page?';
          this.goRenewModal.openModal().toPromise().then((r: string) => {
            this.stateSvc.isRenewOfferShown = true;
            if (r === 'Yes') {
              this.router.navigate(['/app/renew-permit']);
            }
          }, (e) => { });
        }
      });
  }

  mapModel(vm: DashboardViewModel, data: PermitDetailsModel) {

    vm.businessName = data.permitDetails.clientName;
    vm.abn = data.permitDetails.abn;
    vm.contactName = data.permitDetails.firstName + ' ' +  data.permitDetails.lastName;
    vm.permitNo = data.permitDetails.permitNo;
    vm.primaryPhone = data.permitDetails.workPhone;
    vm.customerNo = !!data.permitDetails.hiAffinityNo ? data.permitDetails.hiAffinityNo : 'Not Assigned';
    vm.email = data.permitDetails.email;
    vm.status = data.permitDetails.status;
    vm.startDate =  this.formatter.toDate(this.formatter.fromIsoString(data.permitDetails.startDate));

    this.ios = data.iosLink;
    this.android = data.androidLink;
    
    vm.fullAddress = this.formatAddress(data.permitDetails);

    vm.emsKeys = _(data.permitDetails.emsKeys)
      .map((k) => k.emsNo)
      .sortBy((k) => k)
      .value();
    vm.expiryDate = this.formatter.toDate(this.formatter.fromIsoString(data.permitDetails.expiryDate));
    vm.isExpired = vm.expiryDate < moment().toDate();

    let daysBeforeExpiry = moment.duration(moment(vm.expiryDate).diff(moment())).asDays();

    // one month before
    vm.isRenewable = daysBeforeExpiry < 31;

    vm.vehicles = _(data.vehicles).filter((v: PermitDetailsVehicleItemModel) => {
      return v.status === 'Active';
    })
      .map((v: PermitDetailsVehicleItemModel) => {
        let vi = new DashboardVehicleViewModel();
        vi.regoNo = v.rego;
        vi.capacity = v.capacity;
        vi.vehicleType = v.vehicleType;
        vi.status = 'Active';
        return vi;
      }).value();
    vm.vehicleCount = vm.vehicles.length;

    vm.billingPeriodCount = data.billingPeriodsCount;
    vm.billingPeriods = _.map(data.billingPeriods.slice(0, 5),
      (b: PermitDetailsBillingItemModel) => {
        let bm = new DashboardBillingViewModel();
        bm.billingPeriod = moment(b.endDate).format('MMMM YYYY');
        bm.amount = b.permitFee + b.loggerUsage + b.emsUsage + b.manualUsage;
        return bm;
      });


    vm.currentMonth = new DashboardBillingDetailsViewModel();
    vm.currentMonth.loggerUsage = data.currentMonth.loggerUsage;
    vm.currentMonth.manualUsage = data.currentMonth.manualUsage;
    vm.currentMonth.emsUsage = data.currentMonth.emsUsage;
    vm.currentMonth.permitFee = data.currentMonth.permitFee;
    vm.currentMonth.rolledOver = data.currentMonth.rolledOver;

  }



  formatAddress(data: PermitDetailsItemModel): string {
    let fullAddress = '';
    if (data.address1) { fullAddress = data.address1; }
    if (data.address2) { fullAddress = fullAddress + ' ' + data.address2; }
    if (data.suburb) { fullAddress = fullAddress + ', ' + data.suburb; }
    if (data.postCode) { fullAddress = fullAddress + ', ' + data.postCode; }
    if (data.state) { fullAddress = fullAddress + ' ' + data.state; }

    return fullAddress;
  }
}

export class DashboardViewModel {
  constructor() {
    this.transactions = [];
    this.billingPeriods = [];
    this.vehicles = [];
    this.emsKeys = [];
    this.currentMonth = new DashboardBillingDetailsViewModel();
  }
  public isOpening: boolean;
  public isLoading: boolean;

  public status: string;
  public customerNo: string;
  public businessName: string;
  public abn: string;
  public contactName: string;
  public permitNo: string;
  public email: string;
  public primaryPhone: string;
  public fullAddress: string;

  public startDate: Date;
  public expiryDate: Date;
  public isExpired: boolean;
  public isRenewable: boolean;

  public vehicles: DashboardVehicleViewModel[];

  public vehicleCount: number;
  public backflowPreventionExpiresSoon: number;
  public backflowPreventionExpiredAlready: number;

  public transactions: DashboardTransactionViewModel[];
  public transactionCount: number;

  public billingPeriods: DashboardBillingViewModel[];
  public billingPeriodCount: number;

  public emsKeys: string[];

  public currentMonth: DashboardBillingDetailsViewModel;
}

export class DashboardTransactionViewModel {
  public description: string;
  public transactionType: string;
  public fillDate: Date;
  public suburb: string;
}

export class DashboardBillingViewModel {
  public billingPeriod: string;
  public amount: number;
}

export class DashboardBillingDetailsViewModel {
  public permitFee: number;
  public loggerUsage: number;
  public manualUsage: number;
  public emsUsage: number;
  public rolledOver: number;
  public total: number;
}

export class DashboardVehicleViewModel {
  public regoNo: string;
  public capacity: number;
  public vehicleType: string;
  public status: string;
}
